import React, { Fragment } from 'react';
import config from '@root/config';
import _map from 'lodash/map';
import Router from 'next/router';
import Select from 'react-select';
import _filter from 'lodash/filter';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Header from '@components/Base/Header';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { LocaleContext } from '@contexts/Locale';
import SimpleReactValidator from 'simple-react-validator';

import Filter from './Components/Filters';
import Doctor from './Components/DoctorItem';
import NoResults from './Components/NoResults';
import FilterGender from './Components/Filters/Gender';
import FilterLanguage from './Components/Filters/Language';
import _merge from 'lodash/merge';
import _omit from 'lodash/omit';
import _get from 'lodash/get';
import qs from 'querystring';

import Toast from '@libs/toast';

const step = {
    RESULTS: 0,
    FILTER: 1,
    GENDER: 2,
    LANGUAGE: 3,
    SELECT: 4
}

const pageTitle = [
    'APLIKASI ANTRIAN',
    'Filter',
    'Gender',
    'Language',
    'Selamat datang di aplikasi Antrian',
];

class Results extends React.Component {

    classList = {
        'gender': 'search-filter-fields',
        'result': 'search-form'
    }

    state = {
        loaded: false,
        show: step.RESULTS,
        genderApplied: false,
        tempGender: 'any',
        filter: {
            gender: 'any',
            language: ['any']
        },
        language: [],
        isSearching: false
    }

    validator = false

    static getDerivedStateFromProps(props, state) {
        const { query } = state;
        let { loaded } = state;
        let reload = false;
        if (props.init.loaded && !state.loaded) {
            loaded = true;
            if (!props.speciality) {
                props.widget.actions.GetInitialData(props.facility);
                props.locale.actions.getBlock(props.facility);
            } else {
                reload = true;
            }
        }
        const mergedQuery = _merge(query, props.query);
        return {
            query: mergedQuery,
            loaded,
            reload
        }
    }

    async componentDidMount() {
        this.validator = new SimpleReactValidator({
            messages: {
                required: ':attribute harus di isi.'
            }
        });
        window.validator = this.validator;
        window.updateResult = () => {
            this.UpdateResult();
        }
    }

    componentDidUpdate() {
        if (this.state.reload) {
            this.UpdateResult();
            console.log('load result data');
        }
    }

    UpdateResult = async () => {
        this.setState({
            languages: this.props.spoken
        });
        const params = {
            facility: this.props.facility,
            insurance: this.props.insurance,
            gender: this.props.gender,
            language: this.props.language,
            ...this.state.filter,
            attributesToRetrieve: ['id', 'profilePicture', 'slug', 'specialityIndonesian', 'locations.name', 'title'].join(',')
        }
        if (this.props.speciality !== 'Semua spesialisasi') {
            params.speciality = this.props.speciality
        }
        try {
            await this.props.widget.actions.Search(params);
        } catch (error) {
            Toast.show('Sepertinya ada masalah dengan koneksi internetnya, mohon periksa koneksi anda dan ulangi lagi', 'error', 3000);
        }
    }

    showFilter() {
        this.setState({
            show: step.FILTER
        })
    }

    ResetFilter = () => {
        let { filter, languages } = this.state;
        switch (this.state.show) {
            case step.LANGUAGE:
                languages = _map(this.state.languages, (la) => {
                    la.status = false;
                    return la;
                });
                this.setState({
                    languages
                });
                filter = {
                    ...filter,
                    language: ['any']
                };
                break;
            case step.GENDER:
                filter = {
                    ...filter,
                    gender: 'any',
                    tempGender: 'any'
                };
                break;
            default:
                filter = {
                    gender: 'any',
                    language: ['any'],
                    tempGender: 'any'
                };
                break;
        }
        this.setState({
            filter
        });
    }

    GoBack = () => {
        const { speciality } = this.props;
        let { show, query } = this.state;
        const prefix = config.folder ? config.folder : '/';
        const isDisabledSpeciality = (config.EXCLUDE_SPECIALITY || []).includes(+query.facility);

        if (speciality && !isDisabledSpeciality) {
            const query2 = {
                facility: this.props.facility,
                fcname: this.props.fcname,
                header: this.props.headerHeight
            };
            const mergedQuery = _omit(_merge(query, query2), ['speciality']);
            Router.push(`${prefix}?${qs.stringify(mergedQuery)}`);
            return;
        }

        if (speciality && isDisabledSpeciality) {
            window.history.back();
        }

        if (show > 1) {
            if (show === step.gender) {
                this.setState({
                    filter: {
                        ...this.state.filter,
                        gender: 'any'
                    }
                });
            }
            show = step.FILTER;
        } else if (show === step.FILTER) {
            show = step.RESULTS;
        } else if (show === step.RESULTS) {
            const { query } = this.state;
            const query2 = {
                facility: this.props.facility,
                fcname: this.props.fcname,
                header: this.props.headerHeight
            };
            const mergedQuery = _merge(query, query2);
            Router.push(`${prefix}?${qs.stringify(mergedQuery)}`);
        }

        this.setState({
            show
        });
    }

    onSearchDoctor = () => {
        const prefix = config.folder ? config.folder : '/';
        const { query } = this.state;
        let realQuery = query;
        if (!this.validator.allValid()) {
            realQuery.speciality = 'Semua spesialisasi'
        }

        this.setState({ isSearching: true }, () => {
            window.location.href = `${prefix}results?${qs.stringify(realQuery)}`;
        });
    }

    render() {
        const { widget, theme, speciality, locale, query: { logo }, init } = this.props;
        const specialities = _get(this.props, 'widget.specialities') || [];

        const { filter, query, isSearching } = this.state;
        let { languages } = this.state;

        const right = null;

        let title = pageTitle[this.state.show];
        let title2 = !speciality ? pageTitle[step.SELECT] : '';
        const isDisabledSpeciality = (config.EXCLUDE_SPECIALITY || []).includes(+query.facility);

        const customFooter = _get(init, 'settings.qms_configs.custom_footer') || '';

        return (
            <div className="widget-card card">
                <Header
                    left={(
                        <div className="btn back-button" onClick={() => {
                            this.GoBack()
                        }}>
                            <img src={`${config.STATIC_URL}static/antrian/arrow-left.png`} style={{ maxWidth: '15px' }} />
                        </div>
                    )}
                    logo={logo}
                    title={title}
                    right={right}
                    facilityName={this.props.fcname}
                />
                <div className="full-height search-form">
                    {!speciality && (
                        <React.Fragment>
                            <div className="card-body">
                                <div className="scroll-window">
                                    {locale.queueTicker !== '' && <div dangerouslySetInnerHTML={{ __html: locale.queueTicker }} />}
                                    <div className="font-weight-bold p-3 text-center">
                                        {title2}
                                        <div className="font-weight-bold">{this.props.fcname}</div>
                                    </div>
                                    <div className="scroll-window__card">
                                        {
                                            isDisabledSpeciality && (
                                                <div className="form-group">
                                                    <Form.Label className="text-bold">
                                                        Untuk peta lokasi silahkan klik
                                                    </Form.Label>
                                                    <a href='http://okdc.me/halobumilmaps' className="text-blue text-bold"> http://okdc.me/halobumilmaps.</a>
                                                </div>
                                            )
                                        }
                                        {
                                            !isDisabledSpeciality && (
                                                <div className="form-group">
                                                    <Form.Label htmlFor="speciality" className="text-bold">Cari Dokter berdasarkan Spesialisasi</Form.Label>
                                                    <Select
                                                        instanceId="speciality"
                                                        placeholder='Pilih Spesialisasi'
                                                        options={specialities}
                                                        isSearchable={false}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                query: {
                                                                    ...this.state.query,
                                                                    speciality: e.value
                                                                }
                                                            })
                                                        }} />
                                                    {this.validator && this.validator.message('Spesialisasi', this.state.query.speciality, 'required')}
                                                </div>
                                            )
                                        }

                                        {
                                            locale.popularData.some((group) => group.items && group.items.length > 0) && (
                                                locale.popularData.map((group, gi) => {
                                                    const items = group.items || [];
                                                    if (items.length === 0) {
                                                        return null;
                                                    }

                                                    const buttons = (
                                                        <Row>
                                                            {
                                                                items.map((v, i) => (
                                                                    <div key={i} className="col-sm-6 d-flex my-2">
                                                                        <a
                                                                            href={v.url}
                                                                            className="btn btn-gray btn-gray--border"
                                                                            style={{
                                                                                whiteSpace: 'normal',
                                                                                display: 'flex',
                                                                                flexGrow: '1',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}
                                                                        >
                                                                            <span className="text-blue text-bold">
                                                                                {v.speciality}
                                                                            </span>
                                                                        </a>
                                                                    </div>

                                                                ))
                                                            }
                                                        </Row>
                                                    );

                                                    if (!group.title) {
                                                        return (
                                                            <div className="form-group" key={gi}>
                                                                {
                                                                    isDisabledSpeciality ?
                                                                        <Form.Label htmlFor="speciality" className="text-bold">{this.props.fcname} memiliki 16 lokasi, yaitu:</Form.Label> :
                                                                        <Form.Label htmlFor="speciality" className="text-bold">{group.label || 'Atau pilih dari spesialis populer berikut:'}</Form.Label>
                                                                }
                                                                {buttons}
                                                            </div>
                                                        );
                                                    }

                                                    const iconSrc = group.icon;

                                                    return (
                                                        <div className="form-group speciality-group-card" key={gi} style={group.color ? { borderColor: group.color } : undefined}>
                                                            <div className="speciality-group-card__header" style={group.color ? { borderColor: group.color } : undefined}>
                                                                {
                                                                    iconSrc && (
                                                                        <img src={iconSrc} alt={group.title} className="speciality-group-card__icon" />
                                                                    )
                                                                }
                                                                <span className="speciality-group-card__title" style={group.color ? { color: group.color } : undefined}>
                                                                    {group.title}
                                                                </span>
                                                            </div>
                                                            {
                                                                group.label && (
                                                                    <Form.Label htmlFor="speciality" className="text-bold">{group.label}</Form.Label>
                                                                )
                                                            }
                                                            {buttons}
                                                        </div>
                                                    );
                                                })
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                !isDisabledSpeciality && (
                                    <div className="card-footer" style={{ marginBottom: `${+this.props.headerHeight}px` }}>
                                        <button
                                            className="btn btn-green btn-footer"
                                            onClick={this.onSearchDoctor}
                                            disabled={isSearching}
                                        >
                                            {isSearching ? 'Loading...' : 'Cari Dokter'}
                                        </button>
                                        {customFooter !== '' && <div className="card-custom-footer" style={{ marginBottom: `${+this.props.headerHeight}px` }} dangerouslySetInnerHTML={{ __html: customFooter }} />}
                                    </div>
                                )
                            }

                        </React.Fragment>
                    )}
                    {speciality && this.state.show === step.FILTER && (
                        <Filter step={step} filter={filter} theme={theme} onFilterApply={() => {
                            this.UpdateResult();
                            this.setState({
                                show: step.RESULTS
                            });
                        }} onFilterClick={(filter) => {
                            if (!this.state.genderApplied && filter === step.GENDER) {
                                this.setState({
                                    tempGender: 'any'
                                });
                            }
                            this.setState({
                                show: filter
                            });
                        }} />
                    )}

                    {speciality && this.state.show === step.LANGUAGE && (
                        <FilterLanguage
                            language={languages}
                            theme={theme}
                            onLanguageChange={(l, status) => {
                                if (l === 'any') {
                                    languages = _map(languages, (la) => {
                                        la.status = false;
                                        return la;
                                    });
                                    this.setState({
                                        languages,
                                        filter: {
                                            ...this.state.filter,
                                            language: ['any']
                                        }
                                    });
                                    return;
                                }
                                languages = _map(languages, (la) => {
                                    if (la.value === l.value) {
                                        la.status = status;
                                    }
                                    return la;
                                });
                                const language = _map(languages, (la) => {
                                    if (la.status) {
                                        return la.value;
                                    }
                                });
                                this.setState({
                                    languages,
                                    filter: {
                                        ...this.state.filter,
                                        language
                                    }
                                });
                            }}
                            onLanguageApply={() => {
                                let l = _filter(this.state.languages, (la) => la.status);
                                l = _map(l, (la) => la.value);
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        language: l.length > 0 ? l : ['any']
                                    },
                                    show: step.FILTER
                                })
                            }} />
                    )}

                    {speciality && this.state.show === step.GENDER && (
                        <FilterGender
                            selected={this.state.tempGender}
                            onGenderChange={(gender) => {
                                this.setState({
                                    tempGender: gender
                                })
                            }}
                            theme={theme}
                            onGenderApply={() => {
                                this.setState({
                                    genderApplied: true,
                                    filter: {
                                        ...this.state.filter,
                                        gender: this.state.tempGender
                                    },
                                    show: step.FILTER
                                })
                            }} />
                    )}

                    {speciality && this.state.show === step.RESULTS && (
                        <Fragment>
                            <div className="card-body">
                                <div className="scroll-window">
                                    {widget.search.done && !widget.search.loading && widget.doctors.length < 1 && (
                                        <NoResults onGoBack={() => {
                                            this.GoBack();
                                        }} />
                                    )}
                                    {(widget.search.loading || widget.doctors.length > 0) && (
                                        <React.Fragment>
                                            <div className="scroll-window__title text-center pt-2 pb-3">
                                                <p className="text-bold">ditemukan {widget.doctors.length} {widget.doctors.length > 1 ? 'dokter' : 'dokter'}</p>
                                            </div>
                                            {widget.search.loading && (
                                                <div className="scroll-window__card">
                                                    <strong>Melakukan pencarian...</strong>
                                                    <ProgressBar animated variant="info" now="100" />
                                                </div>
                                            )}
                                            {widget.doctors.length > 0 && (
                                                <div className="scroll-window__card">
                                                    {widget.doctors.map((doctor) => (
                                                        <Doctor {...this.props} doctor={doctor} key={doctor.id} facility={this.props.facility} fcname={this.props.fcname} theme={theme} query={query} />
                                                    ))}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                            {
                                customFooter !== '' && <div className="card-footer" style={{ marginBottom: `${+this.props.headerHeight}px` }} dangerouslySetInnerHTML={{ __html: customFooter }} />
                            }

                        </Fragment>

                    )}
                </div>
            </div>
        )
    }
}

export default (
    (props) => (
        <LocaleContext.Consumer>
            {
                (locale) => (
                    <Results {...props} locale={locale} />
                )
            }

        </LocaleContext.Consumer>
    )
);